import { Link } from '@amzn/awsui-components-core';
import React, { useContext } from 'react';
import { HelpPanelContext } from '../../contexts/HelpPanelContext';

// @ts-expect-error TS7031 - strict migration
const InfoLink = ({ topic }) => {
  const helpPanelContext = useContext(HelpPanelContext);
  return (
    // @ts-expect-error TS2722 - strict migration
    <Link variant="info" onFollow={helpPanelContext.panelHandler(topic)}>
      Info
    </Link>
  );
};

export default InfoLink;
